import { defineStore } from "pinia";
import directus from "@/services/directus";

const BASE_URL = process.env.VUE_APP_DIRECTUS_URL;
const STORE_VERSION = 1;

export const useBannerStore = defineStore("banner", {
  state: () => ({
    banners: [],
    loaded: false,
    version: STORE_VERSION,
  }),

  persist: {
    key: "banner-store",
    storage: localStorage,
  },

  actions: {
    async loadBanners() {
      // 🔥 invalidate old persisted data
      if (this.version !== STORE_VERSION) {
        this.$reset();
        this.version = STORE_VERSION;
      }

      if (this.loaded) return;

      const res = await directus.get("/items/webiste_banners", {
        params: {
          fields: ["id", "status", "banner", "page", "title"],
          filter: { status: { _eq: "active" } },
        },
      });

      this.banners = res.data?.data || [];
      this.loaded = true;

      this.preloadBannerImages();
    },

    preloadBannerImages() {
      if (!BASE_URL) return;

      this.banners.forEach(b => {
        if (!b.banner) return;
        const img = new Image();
        img.src = `${BASE_URL}/assets/${b.banner}`;
      });
    },

    getBannerByPage(page) {
      return this.banners.find(b => b.page === page) || null;
    },
  },
});
